import axios from 'axios';
import Constants from '../constants';

export async function endImpersonateUser(): Promise<any> {
	const res = await axios.delete(Constants.IDENTITY_SERVER_URL + 'api/impersonate');

	if (res.status === 200) {
		return res.data;
	}
}
